import * as types from '../actionTypes/CartActionTypes';

export default function CartDetailsReducer(state = [], action) {
    // NOSONAR
    switch (action.type) {
        case types.CART_DETAILS_GET_REQUEST_SUCCESS:
            return action.cartDetailsResponse;
        case types.UPDATE_APPLE_ELIGIBILITY:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}
